import type { ChangeEvent } from 'react';
import React from 'react';

import styled from 'styled-components';

import { RebrandCheck } from 'src/app/components/icons/rebrand-check';
import { RebrandUncheck } from 'src/app/components/icons/rebrand-uncheck';
import { Tooltip } from 'src/app/components/lib/tooltip';

import { RebrandCheckbox } from './checkbox.styles';

import type { SxProps } from '@mui/material';

export type CheckboxBaseProps = {
  checked?: boolean;
  className?: string;
  disabled?: boolean;
  disabledStateTooltip?: string | null;
  indeterminate?: boolean;
  name?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps;
  value?: any;
};

export function CheckboxBase(props: CheckboxBaseProps) {
  const { checked, indeterminate, name, onChange, disabled, disabledStateTooltip, sx, className, value } = props;

  if (disabledStateTooltip) {
    return (
      <Tooltip placement='top' title={disabledStateTooltip}>
        <CheckboxWrapper>
          <RebrandCheckbox
            checked={checked}
            checkedIcon={<RebrandCheck disabled={disabled} />}
            className={className}
            disabled={disabled}
            icon={<RebrandUncheck disabled={disabled} />}
            indeterminate={indeterminate}
            name={name}
            sx={sx}
            value={value}
            onChange={onChange}
          />
        </CheckboxWrapper>
      </Tooltip>
    );
  }

  return (
    <RebrandCheckbox
      checked={checked}
      checkedIcon={<RebrandCheck disabled={disabled} />}
      className={className}
      disabled={disabled}
      icon={<RebrandUncheck disabled={disabled} />}
      indeterminate={indeterminate}
      name={name}
      sx={sx}
      value={value}
      onChange={onChange}
    />
  );
}

const CheckboxWrapper = styled.div`
  cursor: not-allowed;
  margin-right: 8px;
  position: relative;
  top: -5px;
  width: 16px;
`;
